import { render, staticRenderFns } from "./GratuitiesPopup.vue?vue&type=template&id=2a148630&scoped=true"
import script from "./GratuitiesPopup.vue?vue&type=script&lang=js"
export * from "./GratuitiesPopup.vue?vue&type=script&lang=js"
import style0 from "./GratuitiesPopup.vue?vue&type=style&index=0&id=2a148630&prod&lang=less&scoped=true"
import style1 from "./GratuitiesPopup.vue?vue&type=style&index=1&id=2a148630&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a148630",
  null
  
)

export default component.exports